'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _iBem = require('../i-bem/i-bem.react');

var _bControl = (require('./../control/control.react.js'), (require('./../../desktop.blocks/control/control.react.js').default || require('./../../desktop.blocks/control/control.react.js')).applyDecls());

var _bControl2 = _interopRequireDefault(_bControl);

var _eWrap = (require('./__wrap/textarea__wrap.react.js').default || require('./__wrap/textarea__wrap.react.js')).applyDecls();

var _eWrap2 = _interopRequireDefault(_eWrap);

var _eControl = (require('./__control/textarea__control.react.js').default || require('./__control/textarea__control.react.js')).applyDecls();

var _eControl2 = _interopRequireDefault(_eControl);

var _eBox = (require('./__box/textarea__box.react.js').default || require('./__box/textarea__box.react.js')).applyDecls();

var _eBox2 = _interopRequireDefault(_eBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _iBem.decl)(_bControl2.default, {
    block: 'textarea',
    tag: 'span',
    willInit: function willInit() {
        this.__base.apply(this, arguments);

        this._onChange = this._onChange.bind(this);
    },
    attrs: function attrs(_ref) {
        var style = _ref.style,
            controlAttrs = _ref.controlAttrs,
            _attrs = _ref.attrs;

        var baseAttrs = this.__base.apply(this, arguments);
        controlAttrs && Object.keys(controlAttrs).forEach(function (key) {
            return delete baseAttrs[key];
        });

        return _extends({}, baseAttrs, _attrs, {
            style: style
        });
    },
    mods: function mods(_ref2) {
        var type = _ref2.type,
            theme = _ref2.theme,
            size = _ref2.size,
            pin = _ref2.pin,
            iconLeft = _ref2.iconLeft,
            iconRight = _ref2.iconRight;

        return _extends({}, this.__base.apply(this, arguments), {
            theme: theme,
            size: size
        });
    },
    content: function content(ctx) {
        var _this = this;

        var disabled = this.state.disabled;


        return [_react2.default.createElement(
            _eWrap2.default,
            { key: 'wrap' },
            _react2.default.createElement(_eControl2.default, _extends({
                id: ctx.id,
                name: ctx.name,
                value: ctx.text || '',
                tabIndex: ctx.tabIndex,
                cols: ctx.cols,
                rows: ctx.rows,
                disabled: disabled,
                ref: function ref(c) {
                    return _this._control = _reactDom2.default.findDOMNode(c);
                },
                placeholder: ctx.placeholder,
                autoComplete: ctx.autocomplete === false ? 'off' : undefined,
                onChange: disabled ? undefined : this._onChange
            }, ctx.controlAttrs))
        ), _react2.default.createElement(_eBox2.default, { key: 'box' })];
    },
    _onChange: function _onChange(e) {
        this.props.onChange && this.props.onChange(e.target.value, this.props);
    }
}, {
    propTypes: {
        theme: _propTypes2.default.string.isRequired,
        size: _propTypes2.default.oneOf(['xs', 's', 'm']),
        id: _propTypes2.default.string,
        name: _propTypes2.default.string,
        tabIndex: _propTypes2.default.string,
        text: _propTypes2.default.string,
        placeholder: _propTypes2.default.string,
        autocomplete: _propTypes2.default.bool,
        onChange: _propTypes2.default.func
    },
    defaultProps: {
        cols: 10,
        rows: 10
    }
});